<template>
  <div class="container-fluid ">
    <div class="row report-title">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4 col-xs-12 title-padding">
            <div class="row container-fluid">
              <div class="col-xs-3 mobile-sidebar-viewer">
                <div class="sidebar-icon">
                  <div class="">
                    <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xs-12">
                <h1>{{ mea.abbreviation }} - {{ indicator.name }}</h1>
              </div>

            </div>
          </div>
          <div class="col-sm-2 col-xs-12 ctrl-col">
            <div class="container-fluid" v-if="yearTest()==true">
              <div style="display: inline-block;">
                <report-data-selector :options="years" v-on:select="selectYear" :title="getSelectedYear">
                </report-data-selector>
              </div>
            </div>
            <div class="container-fluid" v-else style="visibility: hidden;">
            </div>
          </div>
          <div class="col-sm-2 col-xs-12 ctrl-col">
           <div style="display: inline-block;" v-if="yearTest()==true">
              <report-data-selector :options="yearOptions" v-on:select="compareYear"
                  :show-custom-table="showCustomTable"
                  title="Compare to" :compare="comparative">
              </report-data-selector>
            </div>
            <div class="container-fluid" v-else style="visibility: hidden;">
            </div>
          </div>
          <div class="col-sm-2 col-xs-12 ctrl-col">
            <div class="float"><select-chart-type></select-chart-type></div>
          </div>
          <div class="col-sm-2 col-xs-12 ctrl-col">
            <dropdown ref="dropdown">
              <btn type="primary" class="dropdown-toggle">Actions <span class="caret"></span></btn>
              <template slot="dropdown">
                <li><a @click="chooseDownload = true">Download</a></li>
                <report-delete v-show="canDelete"></report-delete>
              </template>
            </dropdown>
          </div>
        </div>
      </div>
    </div>
    <div id="card" class="row report-content">
      <div class="col-sm-7 report-data">
        <report-legend :comparative-data="comparativeValues"
           :transformed-comparative-data="transformedComparativeValues"
           :show-custom-table="showCustomTable"
           :show-comparative-data="showComparativeData">
          </report-legend>
      </div>
       <div class="col-sm-5 data-ctrl" style="height:80%; min-height: 550px; max-height:80%;">
          <div class="row chart-container chart-visibility" style="position: absolute;">
              <chart-display :update-chart="updateChart"></chart-display>
          </div>
          <div class="row chart-container separator-visibility" style="position: absolute; z-index:2; background-color: white">
          </div>
          <div class="row chart-container map-visibility" id="map-container" style="position: relative; z-index:3;">
            <h3>Map of {{ indicator.name }}</h3>
            <div id="map" ></div>
          </div>
       </div>
    </div>
    <div class="row row-legend">
      <div class="col-sm-7"></div>
    </div>
    <section>
      <modal v-model="chooseDownload"
             title="Downloads"
             size="lg"
             id="reportDownloadModal"
             ok-text="Download"
             :before-close="coordinateReportDownload">
        <div class="form-group" v-for="(downloadItem , index) in getDownloadableItems(getDataType)">
          <input :key="downloadItem"
                 type="checkbox"
                 :id="'download-' + downloadItem.name.toLowerCase()"
                 :value="downloadItem.name">
          <select v-if="downloadItem.hasOwnProperty('options')"
                  :id="'download-option-' + downloadItem.name.toLowerCase()">
            <option v-for="option in downloadItem.options" :value="option">
              {{ option | capitalize}}
            </option>
          </select>
          <label :for="'download-' + downloadItem.name.toLowerCase()">{{ downloadItem.title }}</label>
        </div>
      </modal>
    </section>
  </div>
</template>

<script>
    import ChartDisplay from './ChartDisplay';
    import ReportLegend from './ReportLegend';
    import MapDisplay from './MapDisplay';
    import ReportDataSelector from './ReportDataSelector';
    import ReportDelete from './ReportDelete';
    import SelectChartType from './SelectChartType';
    import { mapOptions } from '../../map_style';
    import $ from 'jquery';
    import html2canvas from 'html2canvas';

    import store from '../../store.js';
    import { bus } from '../../main';
    import { separateGeoJsonLayers }  from '../../utils';
    import { mapState, mapGetters } from 'vuex';
    import { ReportWizard } from '../../api';

    export default {
        beforeDestroy () {
          console.log('destroying container');
          store.dispatch('resetGeoJsonVars');
        },
        beforeMount () {
          if (this.getDataType === 'shp'){
            store.dispatch('setSelectedYear', this.years[0]);
          }
        },
        updated () {
          if (this.getDataType === 'xlsx' || this.getDataType === 'xls'){
            $('.map-visibility').addClass('do-not-show');
            // $('.chart-visibility').css('z-index', 10);
          }
        },
        props: {
          layerValue: {default: 'AREA'}
        },
        data () {
            return {
              map: null,
              mapLayers: {},
              selectedYear: null,
              comparativeYear: null,
              comparativeValues: {},
              transformedComparativeValues: {},
              showCustomTable: false,
              showComparativeData: false,
              updateChart: false,
              chooseDownload: false,
            }
        },
        computed: {
             chartType: () => store.state.chartType,
          ...mapState({
            years: function(state){
              if (this.getDataType === 'shp') {
                  return state.geoJsonObjects.map(function(gjson){
                    return gjson.label.split('_')[1];
                  });
              } else if (this.getDataType === 'xlsx' || this.getDataType === 'xls') {
                  return Object.keys(store.state.xlsData);
              }

              },
              yearOptions: function(){
                if (this.getDataType === 'shp') {
                  let _this = this;
                  return _this.selectedYear ? _this.years.filter((year) => year != _this.selectedYear) : _this.years;
                }else if (this.getDataType === 'xlsx' || this.getDataType === 'xls') {
                  return [];
                }
              },
              showMap: state => state.showMap,
              reportObject: state => state.reportObject,
              selectedReport: state => state.selectedReport,
              mea: state => state.selectedMea,
              indicator: state => state.indicator,
              layerContainer: function (state) {
                return state.layerContainer;
              },
              canDelete: function(){
                return store.getters.hasPerm('delete_report');
              },
              comparative: state => state.reportObject.comparative
            }),
          ...mapGetters([
            'getDataType',
            'getChartDataWithKey',
            'getDownloadableItems',
            'getLabels',
            'getSelectedYear',
            'isAuthenticated',
            'getUser'
          ])
        },
        methods: {
          toggleSidebar(){
            bus.$emit('toggle-sidebar');
          },
          selectYear: function(year){
            store.dispatch('removeAllLayers');
            let geoJson = null;
            for (let geoJsonObject of store.state.geoJsonObjects){
              if (geoJsonObject.label.includes(year)){
                geoJson = geoJsonObject;
                break;
              }
            }
            if (geoJson){
              geoJson = _.cloneDeep(geoJson);
              store.commit('setGeoJson', geoJson.geo_json);
              store.commit('setGeoJsonObjects', geoJson);
              this.selectedYear = year;
              this.updateChart = true;
            }
            // Rig some notification here I guess;
          },
          compareYear: function(year){
            let _this = this;
            let geoJson = null;
            let comparativeLayerValueTotal;

            for (let geoJsonObject of store.state.geoJsonObjects) {
              if (geoJsonObject.label.includes(year)) {
                geoJson = geoJsonObject;
                break;
              }
            }

            let comparativeGeoJsonLayers = separateGeoJsonLayers(geoJson.geo_json, {}, store.state.shapeLayerKey);

            if (geoJson){
              for (let index in this.getLabels){
                let label = this.getLabels[index];
                let layerValueTotal = this.getChartDataWithKey.find((item) => {
                  return item.key === label;
                });
                if (layerValueTotal){
                  layerValueTotal = layerValueTotal.value
                }
                if (comparativeGeoJsonLayers.hasOwnProperty(label)){
                  comparativeLayerValueTotal = comparativeGeoJsonLayers[label].reduce(function(accumulatedLayerValue, layerFeatures){
                    return accumulatedLayerValue + layerFeatures.properties[_this.layerValue];
                  }, 0);
                } else comparativeLayerValueTotal = 0;
                _this.comparativeValues[label] = Number(comparativeLayerValueTotal).toFixed(2);
                let difference = Number(comparativeLayerValueTotal - layerValueTotal).toFixed(2);
                let percentage =  Number(Number( difference / layerValueTotal) * 100).toFixed(2) ;
                _this.transformedComparativeValues[label] = {
                  'difference': difference,
                  'percentage': percentage
                };
              }

              _this.showComparativeData = true;
            }
            _this.showCustomTable = false;
          },
          yearTest: function(state){
            if (this.getDataType == 'shp'){
              if (Object.keys(store.state.geoJsonObjects).length <= 1){
                return false;
              }
              return true;
            } else if (this.getDataType === 'xls' | this.getDataType === 'xlsx'){
              let data =Object.keys(store.state.xlsData).length;
              if (data<=1) {
                return false;
              }
              else {
                return true;
              }
            }
           },
          coordinateReportDownload: function(){
            let _store = store;
            let _component = this;
            $('#reportDownloadModal [id^=download-]:checked').each(function(index, downloadItem){
              // Gets all the selected report downloads
              // Does this selected report download have options?
              let option = $('~ [id*=option]', downloadItem);
              if (option.length >  0){
                if ($(downloadItem).val() === 'chart'){
                  _store.dispatch('setDisplayType', option.val());
                  // Thinking that I would chain some actions
                  // together to not use a timeout
                  window.setTimeout(function(){
                    html2canvas(document.querySelector("#chart"), {useCORS: true}).then(function(canvas) {
                      let link = document.createElement('a');
                      link.href = canvas.toDataURL();
                      link.download = `${_store.state.reportObject.name}-chart.png`;
                      link.click();
                    });
                  }, 2000);
                }
              } else {
                if ($(downloadItem).val() === 'map'){
                  let element = document.querySelector("#map-container");
                  html2canvas(element, {useCORS: true}).then(function(canvas) {
                      let link = document.createElement('a');
                      link.href = canvas.toDataURL();
                      link.download = `${_store.state.reportObject.name}-map.png`;
                      link.click();
                  });
                  return;
                } else if ($(downloadItem).val() ==='report'){
                  if (_store.state.selectedYear === null || _store.state.comparativeYear === null){
                    _component.$notify({
                      type: 'warning',
                      content: 'Please ensure that multiple years are selected before attempting'
                    });
                    return;
                  }
                }
                _store.dispatch('downloadReport', $(downloadItem).val());
              }
            });
            return true;
          }
        },
        watch: {
          yearOptions: function(newYearOptions){
            this.showCustomTable = false;
            this.showComparativeData = false;
            this.comparativeValues = {};
            this.transformedComparativeValues = {};
          }
        },
        components: {
            ChartDisplay,
            ReportLegend,
            MapDisplay,
            ReportDataSelector,
            ReportDelete,
            SelectChartType
        },
        mounted (){
            if(this.getDataType === 'shp') {
              store.state.map = new google.maps.Map(document.getElementById("map"), mapOptions);
              store.state.map.data.setStyle({
                visible: false
              });
              this.selectedYear = store.state.geoJsonObjects.map(function(gjson){
                return gjson.label.split('_')[1];
              })[0];

              if (store.state.reportObject.hasOwnProperty('comparative')){
                this.comparative = store.state.reportObject.comparative;
              }
              window.map = this.map;
            }else if (this.getDataType === 'xls' || this.getDataType === 'xlsx') {
              $('.map-visibility').addClass('do-not-show');
              $('.chart-visibility').css('z-index', 10);
            }
        },
        async beforeRouteEnter (to, from, next) {
            let report = await ReportWizard.getSelectedReport(to.params.id);
            if (report.hasOwnProperty('error')){
              // Prevent moving to this page
              console.log("Redirect to report list and display error");
              let notificationObject = {
                type: "warning",
                title: "Report Error",
                content: `This report has failed to render.
                          <br/> 
                          <a onclick='
                             var request = new XMLHttpRequest();
                             request.open(
                                 "DELETE" , 
                                 location.origin + 
                                 "/api/api/reports/" + ${to.params.id} + "/");
                             request.setRequestHeader("Authorization", "Token ${localStorage.token}");
                             request.onload = function () {
                                 if (request.status == 204){
                                     location.reload();
                                 } else { 
                                     alert("Deleting Report failed");
			         } 
                             }
                             request.send();
                             '
                             style="cursor: pointer;"
                             class="btn btn-danger">
                             Click Here
                          </a>`,
                html: true
              }; 
              bus.$emit('hide-full-loading');
              bus.$emit('notification', {'data': notificationObject});
              next(false);
            } else {  
              store.dispatch('setComparitive', report.comparative);

              let key = Number(Object.keys(report)[0]);
              let obj = report[key];
              let type = obj.type;
              store.dispatch('setDataType', type);

              await store.dispatch('setupSelectedReport', { report: report });
              store.dispatch('setIndicator', report['indicator']);
              store.dispatch('setMea', report.mea);
              next();
            }
      }
}
</script>

<style scoped lang="scss">
.mobile-sidebar-viewer{
  display: none;
}
.chart-ctrl-container{
    position: relative;
    margin-right: 10px;
    margin-left: 0px;
    color: #416b81;
    font-weight: 900;

    .chart-ctrl{
        position: absolute;
        z-index: 183;
        margin-top: 10px;
        margin-right: 20px;
        right: 0px;
    }
}
.float{
  float: right;
}
.report-ctrl{

  margin-bottom: 15px;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-right: 5px;
  text-align: left;
  font-size: 0.813em;

  button.btn{
    padding: 5px;
  }

  .btn-group>.btn+.dropdown-toggle{
    padding: 5px;
  }
}
.do-not-show {
  display: none;
}
.data-ctrl{
    // background-color: #e8f6ff;
    padding: 10px;
    height: calc(100% - 10px);
}

.report-title .btn{
  border: 1px solid white;
}

.report-title{
    background-color: #04bafc;
    padding: 15px;
    color: white;
    margin-left: -2.5rem;
    margin-right: -2.5rem;
    margin-bottom: 5px;
    height: 60px;
    padding: 10px;
    padding-right: 30px;
    font-size: 79.3% !important;

    // .ctrl-col{
    //   text-align: right;
    // }

    button.btn-primary {
      border: 1px solid white;
    }

    .btn.btn-primary, .btn.btn-primary:focus, .btn.btn-primary.focus{
      border: 1px solid white;
      font-size: 0.85rem;
    }

    h1{
      font-size: 1.3em;
      vertical-align: middle;
      margin-top: 15px;
      font-weight: 400;
      font-family: Roboto,sans-serif;
    }

    .sub-title{
      font-size: 0.813em;
    }
}

.report-content{

  height: calc(100% - 100px);
  margin-top: 20px;

  .data-ctrl{
    .chart-container{
      height: 100%;
      width: 100%;
      margin: 0px;
    }
  }
  .report-data{
    height: 100%;
    padding-right: 30px;

    .legend-container{
      height: calc(100% - 80px);

      .legend-row{
          height: 100%;
      }
    }
  }

}
.eis-content{
  overflow: auto;
  padding-top: 0px;
}

.eis-content {
    padding-top: 0px;

    .container-fluid{
        height: 100%;
    }
    .map-col{
        height: 100%;
    }

    .row-legend{
        height: 43%;
        overflow: auto;
    }
}
.chart-row{

    height: 40%;
    margin-left: -2.5rem;
    margin-right: -2.5rem;

    .chart-container{
        height: calc(100% - 15px);
    }
}

#map-container{
  h3{
    position: absolute;
    top: 30px;
    margin: auto;
    z-index: 10;
    width: 293px;
    margin-left: 30px;
    color: #19374a;
  }
}

.chart-col{
    overflow: hidden;
    height: 100%;
    margin-top: -6px;
}
#map{
    height: 100%;
    width: 100%;
}

#reportDownloadModal{
  .form-group{
    height: 30px;

    &:last-child{
      margin-bottom:initial;
    }

    input[type=checkbox]{
      width: initial;
      height:initial;
    }
    .option {
      border-top: 1px solid #e5e5e5;
      padding-top: 10px;
      margin-left: 30px;
      margin-right: 60px;

      label {
        font-size: 85%;
        font-variant: all-small-caps;
        font-weight:bold;
      }

      select {
        font-size: 75%;
      }

    }

    select {
      -webkit-appearance: menulist-button;
      appearance: menulist-button;
      height: initial !important;
      display: inline-block;
    }
  }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  .align-year-select{
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .report-title{
    height: auto;
  }
  .float{
    float: left;
  }
  .ctrl-col{
      text-align: left;
      float: left;
      padding-top:5px;
  }
  .title-padding{
    padding-bottom:5px;
  }
  .fa {
    display: inline-block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 30px;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .mobile-sidebar-viewer{
    display: block;
  }
}
@media only screen and (min-width: 768px) {
  .align-year-select{
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .report-title{
    height: auto;
  }
  .float{
    float: left;
  }

  .ctrl-col{
      text-align: left;
      float: left;
      padding-top:5px;
  }
  .title-padding{
    padding-bottom:5px;
  }
  .fa {
    display: inline-block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 30px;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

}
@media only screen and (max-width: 468px) {
  .align-year-select{
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .report-title{
    height: auto;
  }
 .float{
    float: left;
  }
  .ctrl-col{
      text-align: left;
      float: left;
      padding-top:5px;
  }
  .title-padding{
    padding-bottom:5px;
  }
  .fa {
    display: inline-block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 30px;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .mobile-sidebar-viewer{
    display: block;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/report/ReportContainer.vue